import script from "./VariantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantCard.vue?vue&type=script&setup=true&lang=js"

import "./VariantCard.vue?vue&type=style&index=0&id=2e7d2e9b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e7d2e9b"]])

export default __exports__